<script>
  // import icons from "../../../public/df_assets/img/icons/icons.json";
  // import icons from "../../../public/df_assets/img/icons/icons.svg";
  import { icons } from "../../stores/icons";

  export let name = false;
  export let src = false;

  export let path = false;
  export let pathW = null;
  export let pathH = null;

  export let size = 24;
  export let fill = null;
  export let stroke = null;
  export let strokeWidth = null;
  export let centered = false;

  let d, width, height, w, h;

  if (name) {
    h = 24;
    w = 24;
    height = size;
    width = size;
    d = $icons.find((d) => d.name === name).g;
  } else if (src) {
    width = size;
  } else if (path) {
    d = path;
    h = pathH;
    w = pathW;
    width = size;
    height = pathH * (width / w);
  }

  const getStyles = () => {
    const transform = [],
      styles = [];

    if (size) {
      styles.push(["width", `${width}px`]);
      if (name) {
        styles.push(["height", `${height}px`]);
      }
    }

    if (fill) {
      styles.push(["fill", fill !== null ? fill : "currentColor"]);
    }

    if (stroke) {
      styles.push(["stroke", stroke !== null ? stroke : "none"]);
    }

    if (strokeWidth) {
      styles.push(["stroke-width", strokeWidth !== null ? strokeWidth : 1]);
    }

    if (centered) {
      styles.push(["margin", "auto"]);
    }

    return styles.reduce((cur, item) => {
      return `${cur} ${item[0]}:${item[1]};`;
    }, "");
  };

  $: style = getStyles(size, fill, stroke);
</script>

{#if name}
  <svg {width} {height} viewBox="0 0 {w} {h}" {style}>
    {@html d}
  </svg>
{:else if path}
  <svg {width} {height} viewBox="0 0 {w} {h}" {style}>
    <path {d} />
  </svg>
{:else if src}
  <span {style}>
    <img {src} alt="" width="{width}px" />
  </span>
{/if}

<!-- {#if icon}
  <svg {...icon.attrs} style={`transform: rotate(${rotation}deg);`}>
    <g>
      {@html icon.contents}
    </g>
  </svg>
{/if} -->
<style>
  /* svg {
    width: 1em;
    height: 1em;
    overflow: visible;
    transform-origin: 50% 50%;
  } */
</style>
